import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1000px;
  display: flex;
  overflow-x: auto;

  flex-direction: column;

  h1 {
    text-align: left;
    margin-bottom: 15px;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }

  .services {
    width: 100%;
    overflow-x: auto;
  }

  .filters-row {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 20px;
    background: #fff;
    padding: 20px;
    border-radius: 15px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
    align-items: flex-end;
  }

  .service {
    background-color: #f1f1f1;
    border: 1px solid #0000001c;
    padding: 12px;
    width: 1000px;
    display: flex;
    border-radius: 5px;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;

    div {
      flex: 1;
    }

    img {
      width: 75px;
      height: 75px;
      border-radius: 75px;
    }

    .infos {
      width: 250px;
      display: flex;
      flex-direction: column;
      margin: 0 12px;
    }

    .actions {
      flex: 1;
      display: flex;
      justify-content: flex-end;
      margin-right: 35px;
    }

    button {
      padding: 4px 8px;
      border-radius: 50px;
      font-size: 12px;
      margin-left: 12px;
      justify-self: flex-end;
      font-weight: 500;
      font-family: Montserrat;
    }
  }
`;

export const Card = styled.div`
  border-radius: 8px;
  width: 165px;
  height: 45px;
  padding: 0 25px;
  border-radius: 50px;
  margin-bottom: 15px;
  background: #008037;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 17px;
  font-family: Montserrat;
  color: #fff;
  font-weight: 600;
`;
